import { Game } from "./game/game";

// Boot: grab the canvas, kick off the VT323 font load, start the game.
const canvas = document.getElementById("game") as HTMLCanvasElement | null;
if (!canvas) throw new Error("#game canvas not found");

const boot = document.getElementById("boot");
if (boot) boot.remove();

// Reveal the on-screen touch controls (and enable touch input) on touch devices.
if ("ontouchstart" in window || navigator.maxTouchPoints > 0) {
  document.body.classList.add("touch");
}

// Preload the fonts so canvas text picks them up ASAP (the canvas re-renders
// every frame, so they swap in automatically once ready).
if (document.fonts?.load) {
  for (const f of ['700 32px "Orbitron"', '900 32px "Orbitron"', '400 16px "Chakra Petch"', '700 16px "Chakra Petch"']) {
    void document.fonts.load(f).catch(() => {});
  }
}

const game = new Game(canvas);
game.start();
